import { AxiosInstance } from 'axios';
import {
  ProjectResponse,
  ProjectsResponse,
} from 'data/terra/api/terra/response/ProjectResponse';
import { CreateProjectRequest, UpdateProjectRequest } from 'data/terra/Project';
import { result, Result } from 'util/result';
import { apiResult } from 'util/apiResult';

class ProjectEndpoint {
  getProjectsUrl = () => 'api/v1/projects';
  addProjectsUrl = () => 'api/v1/projects';
  updateProjectsUrl = (projectId: string) => `api/v1/projects/${projectId}`;
  getProjectDetailUrl = (projectId: string) => `api/v1/projects/${projectId}`;
}

export class ProjectApi {
         terraClient: AxiosInstance;
         endpoint = new ProjectEndpoint();

         constructor(client: AxiosInstance) {
           this.terraClient = client;
         }

         addProject(
           desc: CreateProjectRequest
         ): Promise<Result<ProjectResponse>> {
           return result(
             async () =>
               (
                 await this.terraClient.post<ProjectResponse>(
                   this.endpoint.addProjectsUrl(),
                   desc
                 )
               ).data
           );
         }

         updateProject(
           desc: UpdateProjectRequest,
           projectId: string
         ): Promise<Result<ProjectResponse>> {
           return result(
             async () =>
               (
                 await this.terraClient.put<ProjectResponse>(
                   this.endpoint.updateProjectsUrl(projectId),
                   desc
                 )
               ).data
           );
         }

         fetchProject(projectId: string): Promise<Result<ProjectResponse>> {
           return apiResult(
             async () =>
               (
                 await this.terraClient.get<ProjectResponse>(
                   this.endpoint.getProjectDetailUrl(projectId)
                 )
               ).data
           );
         }

         fetchProjects({
           organizationId,
           page,
           pageSize = 200,
         }: {
           organizationId?: number;
           page: number;
           pageSize?: number;
         }): Promise<Result<ProjectsResponse>> {
           return result(
             async () =>
               (
                 await this.terraClient.get<ProjectsResponse>(
                   this.endpoint.getProjectsUrl(),
                   {
                     params: {
                       organizationId,
                       page,
                       pageSize,
                     },
                   }
                 )
               ).data
           );
         }
       }
